import Pagination from '../Pagination/index';

export default {
    plans: null,
    error: '',
    materials: null,
};
